// src/components/AdminBar.jsx
import React from 'react'
import FlatIcon from './FlatIcon'
import { Link, useLocation } from 'react-router-dom'
import { getSession } from '../lib/authDev'

/**
 * AdminBar
 * Renders a top "card" with the admin navigation tiles.
 * Props:
 *  - title?: string   -> heading on the left (e.g., "Users", "Communities", "Overview")
 *  - subtitle?: string (optional)
 *  - active?: 'communications' | 'users' | 'communities' | 'groups' | 'system' (optional, for highlighting)
 */
export default function AdminBar({ title = 'Admin', subtitle, active }) {
  const sess = getSession()
  const isSysconfig = String(sess?.adminLevel || '').toLowerCase() === 'sysconfig'
  const { pathname } = useLocation()

  // If active not passed, infer from URL
  const inferredActive =
    active ||
    (pathname === '/admin'                       ? 'communications' :
     pathname.startsWith('/admin/users')        ? 'users' :
     pathname.startsWith('/admin/communities')  ? 'communities' :
    //  pathname.startsWith('/admin/groups')       ? 'groups' :
     (pathname.startsWith('/admin/compliance') || pathname.startsWith('/compliance/settings')) ? 'compliance' :
     pathname.startsWith('/admin/system')       ? 'system' : null)

  const tiles = [
    { key:'communications', to:'/admin',          icon:'megaphone', title:'Communications', sub:'Announcements & email updates' },
    { key:'users',       to:'/admin/users',       icon:'users', title:'Users',         sub:'Manage people & roles' },
    { key:'communities', to:'/admin/communities', icon:'building', title:'Communities',   sub:'Properties & aliases' },
    ...((import.meta.env.VITE_COMPLIANCE_ENABLED !== 'false') ? [{ key:'compliance', to:'/compliance/settings', icon:'clipboard', title:'Compliance Settings', sub:'Routing & calendars' }] : []),
    // { key:'groups',      to:'/admin/groups',      icon:'🧩', title:'Groups',        sub:'Access groups & memberships' },
    isSysconfig
      ? { key:'system',  to:'/admin/system',      icon:'gear', title:'System Config', sub:'Facility types, limits, etc.' }
      : { key:'system',  to:null,                 icon:'gear', title:'System Config', sub:'Requires sysconfig', disabled:true },
  ]

  return (
    <div className="card">
      <div className="admin-head" style={{ marginBottom: 8 }}>
        {title && <h3 style={{ margin: 0 }}>{title}</h3>}
        {subtitle && <div className="muted">{subtitle}</div>}
      </div>

      <div className="admin-tiles" role="list">
        {tiles.map(t => {
          const isActive = inferredActive === t.key
          const Tag = t.to ? Link : 'div'
          return (
            <Tag
              key={t.key}
              to={t.to || undefined}
              className={`admin-tile${isActive ? ' admin-tile--active' : ''}${t.disabled ? ' admin-tile--disabled' : ''}`}
              role="listitem"
              aria-disabled={t.disabled ? 'true' : undefined}
              data-tooltip={t.disabled ? 'Requires sysconfig' : undefined}
            >
              <div className="admin-tile-icon"><FlatIcon name={t.icon}/></div>
              <div className="admin-tile-title">{t.title}</div>
              <div className="admin-tile-sub">{t.sub}</div>
            </Tag>
          )
        })}
      </div>
    </div>
  )
}
